import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgUpC({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 10.376L8.713 12.7a1 1 0 01-1.426-1.402l3.998-4.066.002-.002a1 1 0 011.414-.011l.014.013 3.998 4.066a1 1 0 11-1.426 1.402L13 10.376V16a1 1 0 01-2 0v-5.624zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
        fill={color}
      />
    </svg>
  )
}

export default SvgUpC
